export default {

    getUrlApi() {
        const hostname = window.location.hostname === 'odonto.molens.com.br' ? 'odonto-api.molens.com.br' : window.location.hostname + ':5050'
        return `${window.location.protocol}//${hostname}/odonto/api`
    },

    getUrlKeycloak() {
        const hostname = window.location.hostname === 'odonto.molens.com.br' ? 'auth.molens.com.br' : window.location.hostname + ':2020'
        return `${window.location.protocol}//${hostname}`
    },
}
